import type { ReactNode } from 'react'
import { MemberBottomSheet } from '../../Member/controls/MemberControlsPrimitives'

type MobileSheetProps = {
  open: boolean
  onClose: () => void
  title?: ReactNode
  hint?: ReactNode
  children: ReactNode
  footer?: ReactNode
  maxHeightFraction?: number
  ariaLabel?: string
  testId?: string
}

const titleToString = (title: ReactNode, ariaLabel?: string): string | undefined => {
  if (typeof title === 'string') return title
  if (typeof title === 'number') return String(title)
  return ariaLabel
}

export const MobileSheet = ({
  open,
  onClose,
  title,
  hint,
  children,
  footer,
  maxHeightFraction = 0.82,
  ariaLabel,
  testId,
}: MobileSheetProps) => (
  <MemberBottomSheet
    open={open}
    onClose={onClose}
    title={titleToString(title, ariaLabel)}
    maxHeightSvh={Math.round(maxHeightFraction * 100)}
    testId={testId}
  >
    <div className="memberChatSheet">
      {hint ? <p className="memberChatSheet__hint">{hint}</p> : null}
      <div className="memberChatSheet__body">{children}</div>
      {footer ? <footer className="memberChatSheet__foot">{footer}</footer> : null}
    </div>
  </MemberBottomSheet>
)
